module.exports = __webpack_public_path__ + "img/truck-classic.1c26c804.svg";